// RepostDropdown.js - Dropdown for reposting published posts

import React, { useState, useEffect, useRef } from "react";

const RepostDropdown = ({ 
  post, 
  onPostNow, 
  onSchedule
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleOptionClick = (action) => {
    setIsOpen(false);
    
    switch (action) {
      case 'post-now':
        onPostNow(post);
        break;
      case 'schedule':
        onSchedule(post);
        break;
      default:
        break;
    }
  };

  return (
    <div className="approval-dropdown-container repost-dropdown-container" ref={dropdownRef} id={`repostDropdown-${post.providerKey || post.provider}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="social-post-repost-btn approval-dropdown-trigger"
        id={`repostDropdownTrigger-${post.providerKey || post.provider}`}
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        Repost
        <svg 
          className={`approval-dropdown-chevron ${isOpen ? 'open' : ''}`}
          width="16" 
          height="16" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2"
        >
          <path d="M6 9l6 6 6-6"/>
        </svg>
      </button>
      
      {isOpen && (
        <div className="approval-dropdown-menu" id={`repostDropdownMenu-${post.providerKey || post.provider}`}>
          <button
            onClick={() => handleOptionClick('post-now')}
            className="approval-dropdown-option approval-dropdown-post-now"
            id={`repostDropdownPostNow-${post.providerKey || post.provider}`}
          >
            <div className="approval-dropdown-option-content">
              <span className="approval-dropdown-option-title">Post Now</span>
              <span className="approval-dropdown-option-description">
                Schedule for immediate publishing
              </span>
            </div>
          </button>
          
          <button
            onClick={() => handleOptionClick('schedule')}
            className="approval-dropdown-option approval-dropdown-custom-schedule"
            id={`repostDropdownSchedule-${post.providerKey || post.provider}`}
          >
            <div className="approval-dropdown-option-content">
              <span className="approval-dropdown-option-title">Schedule</span>
              <span className="approval-dropdown-option-description">
                Choose specific date and time
              </span>
            </div>
          </button>
        </div>
      )}
    </div>
  );
};

export default RepostDropdown;
